import React from "react";
import AuthCard from "../molecules/AuthCard/AuthCard";

type Props = {};

const SalesCard: React.FC<Props> = () => {
  return (
    <AuthCard
      type="sales"
      heading="Sales"
      subHeading="Launch sales campaigns with a few clicks."
      url="https://app.regie.ai"
      onButtonClick={() => {
        window.location.href = process.env.REACT_APP_SALES_URI;
      }}
    />
  );
};

export default SalesCard;
